class FacebookLogin {
  constructor(fbClientId, language) {
    this.init();
    // TODO: add language to settings
    this.language = language || "en_US";
    this.fbClientId = fbClientId;
  }

  loadSdkAsynchronously() {
    ((d, s, id) => {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = `https://connect.facebook.net/${this.language}/sdk.js`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }

  setFbAsyncInit() {
    const _this = this;
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: _this.fbClientId,
        cookie: true,
        xfbml: true,
        version: "v3.1",
      });
      //   window.FB.getLoginStatus(function (response) {
      //     _this.statusChangeCallback(response);
      //   });
    };
  }

  responseApi(authResponse, facebookLoginCallback) {
    window.FB.api(
      "/me",
      { locale: this.language, fields: "name,email,picture" },
      (me) => {
        facebookLoginCallback &&
          facebookLoginCallback(Object.assign(me, authResponse));
      }
    );
  }

  init() {
    if (document.getElementById("facebook-jssdk")) return;
    this.loadSdkAsynchronously();
    this.setFbAsyncInit();
  }

  statusChangeCallback(response, facebookLoginCallback) {
    if (response.status === "connected") {
      console.log("Logged in and authenticated");
      // facebook登录成功
      if (response.authResponse) {
        this.responseApi(response.authResponse, facebookLoginCallback);
      }
    } else {
      // fb未登录
      console.log("Not authenticated");
    }
  }

  getIsMobile() {
    let isMobile = false;

    try {
      isMobile = !!(
        (window.navigator && window.navigator.standalone) ||
        navigator.userAgent.match("CriOS") ||
        navigator.userAgent.match(/mobile/i)
      );
    } catch (ex) {
      // continue regardless of error
    }

    return isMobile;
  }

  checkLoginState() {
    const _this = this;
    FB.getLoginStatus(function (response) {
      _this.statusChangeCallback(response);
    });
  }
}
